import { makeStyles } from '@material-ui/core/styles';
import { dataCodeFields } from '../../../config/dataCodes';
import { USA_States } from '../../../config/dataCodes';
import {
  getRegionByStateName,
  getStateByCode,
  getRegionByGlobalRegion,
  getOriginByCode,
  getEthnicityByCode,
  getIncomeByCode_EU,
  getIncomeByCode_UK,
  getIncomeByCode_USA,
  getCountryByCode
} from '../../../helperFunctions';

const useStyles = makeStyles(theme => ({
  table: {
    width: '100%',
  },
  tableItem: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0,0,0,0.05)',
    padding: '4px 0px',
  },
  tableKey: {
    flex: 1,
  },
  tableValue: {
    flex: 1,
  },
}));

const ConsumerDataInfoTable = ({ data }) => {
  const classes = useStyles();

  // Add Region to data (doing through loop to order Region right beneath State)
  const reOrderedMostOccurring = {};
  const isUSAData = data.most_occurring.State;
  const isUKData = getCountryByCode(data.most_occurring.Country).includes('United Kingdom');
  for (const key of Object.keys(data.most_occurring)) {
    // Currently we don't support City and ZIP (Even though we have the fields in most_occurring)
    if(key === 'City' || key === 'ZIP') continue;

    if (key === 'Ethnicity') {
      reOrderedMostOccurring['Ethnicity/Origin'] = isUSAData
        ? getEthnicityByCode(data.most_occurring[key])
        : getOriginByCode(data.most_occurring[key]);
    } else if (key === 'Income') {
      reOrderedMostOccurring['Income'] = isUSAData
        ? getIncomeByCode_USA(data.most_occurring[key])
        : isUKData
        ? getIncomeByCode_UK(data.most_occurring[key])
        : getIncomeByCode_EU(data.most_occurring[key]);
    } else {
      reOrderedMostOccurring[key] = data.most_occurring[key];
    }

    if (isUSAData) {
      if (key === 'State') {
        reOrderedMostOccurring['Region'] = getRegionByStateName(getStateByCode(data.most_occurring.State)) || '-';
      }
    } else {
      if (key === 'Country') {
        reOrderedMostOccurring['Region'] = data.most_occurring[key];
      }
    }
  }

  const mapValue = (key, value) => {
    if (key == 'State') {
      let result = USA_States.find(e => e.value == value);
      return result?.text || '-';
    }

    if (key == 'Region') {
      return getRegionByGlobalRegion(value) || '-';
    }

    if (key == 'Ethnicity/Origin' || key == 'Income') {
      return value || '-';
    }

    let result = dataCodeFields[key].find(e => e.value == value);
    return result?.text || '-';
  };

  const age = data.average.Age;

  return (
    <div className={classes.table}>
      <div className={classes.tableItem}>
        <span className={classes.tableKey}>Age</span>
        <span className={classes.tableValue}>{age ? data.average.Age.toFixed(0) : '-'}</span>
      </div>
      {Object.keys(reOrderedMostOccurring).map((key, idx) => {
        return (
          <div key={idx} className={classes.tableItem}>
            <span className={classes.tableKey}>{key}</span>
            <span className={classes.tableValue}>
              {typeof reOrderedMostOccurring[key] == 'number' && key != 'ZIP'
                ? mapValue(key, reOrderedMostOccurring[key]) || '-'
                : reOrderedMostOccurring[key] || '-'}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ConsumerDataInfoTable;
